import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  OnChanges,
  SimpleChange,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  AfterViewInit
} from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import {
  CartProductService,
  PriceRequestService,
  ProductService,
  ProductRepoService,
  ProductRepoTypeValueService,
  OrderService
} from '@app/api/api';
import { ToastrService } from 'ngx-toastr';
import { Subscription, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { environment } from 'environments/environment';
import objectPath from 'object-path';
import * as _ from 'lodash';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { AppProductBottomSheetComponent } from '../app-product-bottom-sheet/app-product-bottom-sheet.component';
import { CategoryService } from '@app/api/api';
import { UtilService } from '@app/services/util.service';
import { AppState } from '../../../../core/reducers';
import { AuthService, currentUser, Logout } from '../../../../core/auth';
import { Observable } from 'rxjs';
import { User } from '@app/model/user';
import { select, Store } from '@ngrx/store';
import { ModalCreateSignInUpComponent } from '@app/views/pages/sign-in-up/modal-create-sign-in-up/modal-create-sign-in-up.component';
import { MatDialog } from '@angular/material';
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from '@app/core/_base/layout';

type ProductInformationTab = 'details' | 'description' | 'policy' | 'supplier_quotes';
@Component({
  selector: 'meu-app-product-details',
  templateUrl: './app-product-details.component.html',
  styleUrls: ['./app-product-details.component.scss']
})
export class AppProductDetailsComponent implements OnInit, AfterViewInit, OnDestroy {
  /*for orderdetail component*/
  @Input() productIdFromAdminPage;
  @Output() isAddProductEmit: EventEmitter<any> = new EventEmitter();
  /*-------------------------*/
  private subscriptions: Subscription[] = [];
  productId: any;
  productData: any = {};
  rawProductData: any = null;
  currentLang: string = 'vi';
  recentlyViewed$ = new Subject();
  price = 0;
  originPrice = 0;
  save = 0;
  host = environment.backendhost;
  imgSelectedIndex = 0;
  quantity: number = 0;
  lstTypeSelectedId: any = [];
  lstTypeSelectedId$: any = new Subject();
  isRequestprice: boolean = false;
  quantitySelected: number = 1;
  subTypeId: any;
  warehouseStocks: Array<{
    name: string;
    quantity: number;
  }> = [];
  elScrollImg;

  pathCategory = '';
  treeData = [];
  TREE = [];
  load_tree_path = [];

  user$: Observable<User>;
  isLogin: boolean = false;
  isAdmin: boolean = false;
  supplierQuotesCount: number = 0;

  rootDocumentTitle = 'BimBim - Dịch vụ Logistics & Vận tải hàng đầu Việt Nam';
  vatValue = 0;
  activeProductInformationTab: ProductInformationTab = 'details';

  constructor(
    private productService: ProductService,
    private activatedRoute: ActivatedRoute,
    private bottomSheet: MatBottomSheet,
    private priceRequestService: PriceRequestService,
    private cartProductService: CartProductService,
    private toastrService: ToastrService,
    private router: Router,
    private orderService: OrderService,
    private categoryService: CategoryService,
    private changeDetectorRef: ChangeDetectorRef,
    private store: Store<AppState>,
    private dialog: MatDialog,
    private titleService: Title,
    private metaService: Meta,
    private translate: TranslateService,
    private productRepoService: ProductRepoService,
    private productRepoTypeValueService: ProductRepoTypeValueService,
    @Inject(DOCUMENT) private document: Document,
    private translationService: TranslationService
  ) {}

  ngOnChanges(changes: SimpleChanges) {}
  selectProductInformationTab(tab: ProductInformationTab) {
    this.activeProductInformationTab = tab;
  }
  ngOnInit() {
    this.currentLang = this.translationService.getSelectedLanguage() || localStorage.getItem('language') || 'vi';
    this.subscriptions.push(
      this.translationService.language$.subscribe((lang) => {
        if (lang && lang !== this.currentLang) {
          this.currentLang = lang;
          this.applyProductLanguage(lang);
        }
      })
    );
    this.orderService.apiOrdersVatConfigGet().subscribe((res) => {
      if (res && res.success) {
        this.vatValue = res.data || 0;
      }
    });
    this.user$ = this.store.pipe(select(currentUser));
    this.user$.subscribe((res) => {
      const token = localStorage.getItem(environment.authTokenKey);
      const hasToken = !!(token && token.length > 10);

      if (res == undefined && !hasToken) {
        this.isLogin = false;
        this.isAdmin = false;
      } else {
        this.isLogin = true;
        this.isAdmin = this.checkIsAdmin(res);
      }
    });

    // this.lstTypeSelectedId$.subscribe((data) => {
    //   this.productData.extend_product_type.map((item) => {
    //     if (_.difference(item.type_id, data).length === 0) {
    //       this.subTypeId = item.id;
    //       this.price = item.price;
    //       this.originPrice = item.origin_price;
    //       this.quantity = this.normalizeQuantity(item.quantity);
    //       this.quantity == 0 ? (this.quantitySelected = 1) : null;
    //       this.save = Math.round(100 - (this.price / this.originPrice) * 100);
    //       return;
    //     }
    //   });
    // });
    this.lstTypeSelectedId$.subscribe((data) => {

      if (!this.productData.extend_product_type || !data) {
        this.warehouseStocks = [];
        return;
      }

      const selectedVariant = this.productData.extend_product_type.find(
        (item) =>
          item.type_id &&
          item.type_id.length === data.length &&
          _.difference(item.type_id, data).length === 0
      );

      if (!selectedVariant) {
        this.subTypeId = null;
        this.quantity = 0;
        this.warehouseStocks = [];
        return;
      }

      this.subTypeId = selectedVariant.id;
      this.price = selectedVariant.price;
      this.originPrice = selectedVariant.origin_price;
      this.quantity = this.normalizeQuantity(selectedVariant.quantity);

      this.save =
        this.originPrice > 0 ? Math.round(100 - (this.price / this.originPrice) * 100) : 0;

      this.loadSelectedVariantWarehouses();
    });
    this.getProductData();
  }
  getProductData() {
    this.categoryService
      .apiCategoriesGet()
      .pipe(
        catchError((error) => {
          if (error.status === 401) {
            console.warn('Unauthorized access to categories, but continuing');
          }
          // Trả về empty data để không bị crash
          return throwError(error);
        })
      )
      .subscribe(
        (r) => {
          if (r.success) {
            this.treeData = r.data.collection;
            this.TREE = this.buildTree(this.treeData);

            if (this.productIdFromAdminPage && this.productIdFromAdminPage != '') {
              this.productId = this.productIdFromAdminPage;

              this.getProductById(this.productId);

              this.getRecentlyViewed();
              this.isRequestprice = true;
            } else {
              this.activatedRoute.paramMap.subscribe((paramMap) => {
                if (
                  this.activatedRoute.snapshot.params.id !== null &&
                  this.activatedRoute.snapshot.params.id !== ''
                ) {
                  this.productId = this.activatedRoute.snapshot.params.id;
                  this.isRequestprice = /preview/.test(window.location.href) ? true : false;
                  this.quantitySelected = 1;
                  this.imgSelectedIndex = 0;
                  this.getProductById(this.productId);
                  this.getRecentlyViewed();
                }
              });
            }
          }
        },
        (error) => {
          // Nếu không load được categories, vẫn cho phép load product
          console.error('Error loading categories:', error);
          if (this.productIdFromAdminPage && this.productIdFromAdminPage != '') {
            this.productId = this.productIdFromAdminPage;
            this.getProductById(this.productId);
            this.getRecentlyViewed();
            this.isRequestprice = true;
          } else {
            this.activatedRoute.paramMap.subscribe((paramMap) => {
              if (
                this.activatedRoute.snapshot.params.id !== null &&
                this.activatedRoute.snapshot.params.id !== ''
              ) {
                this.productId = this.activatedRoute.snapshot.params.id;
                this.isRequestprice = /preview/.test(window.location.href) ? true : false;
                this.quantitySelected = 1;
                this.imgSelectedIndex = 0;
                this.getProductById(this.productId);
                this.getRecentlyViewed();
              }
            });
          }
        }
      );
  }
  applyProductLanguage(lang: string) {
    if (!this.rawProductData) {
      return;
    }

    const currentLanguage = lang || this.translationService.getSelectedLanguage() || localStorage.getItem('language') || 'vi';
    let localizedData = null;

    if (currentLanguage === 'en' && this.rawProductData.extend_product_en) {
      localizedData = this.rawProductData.extend_product_en;
    } else if ((currentLanguage === 'zh' || currentLanguage === 'ch') && this.rawProductData.extend_product_zh) {
      localizedData = this.rawProductData.extend_product_zh;
    }

    this.productData = {
      ...this.rawProductData,
      name: (localizedData && localizedData.name) || this.rawProductData.name,
      summary: (localizedData && localizedData.summary) || this.rawProductData.summary,
      description: (localizedData && localizedData.description) || this.rawProductData.description,
      note: (localizedData && localizedData.note) || this.rawProductData.note
    };

    if (this.productData && this.productData.name) {
      this.titleService.setTitle(this.productData.name + ' - BimBim');
      this.setupSEOTags();
    }

    this.changeDetectorRef.markForCheck();
  }

  ngAfterViewInit() {
    this.elScrollImg = document.getElementById('scroll-img');
  }
  buildTree(data) {
    let rootNode = data.filter((x) => x.parent_id == null);
    let treeobject = [];
    rootNode.forEach((element) => {
      let aChildren = data.filter((x) => x.parent_id == element.id);
      const node = new Object();
      node['id'] = element.id;
      node['name'] = element.name;
      node['parent_id'] = element.parent_id;
      node['path'] = element.name;
      let lstChildren = this.builDataChildren(aChildren, data, node);
      node['children'] = lstChildren;
      treeobject.push(node);
      this.load_tree_path.push(node);
    });
    return treeobject;
  }

  builDataChildren(aChildren, allChildren, parent) {
    let objectReturn = [];
    aChildren.forEach((element) => {
      let aChild = allChildren.filter((x) => x.parent_id == element.id);
      const node = new Object();
      node['id'] = element.id;
      node['name'] = element.name;
      node['path'] = parent.path + ' › ' + element.name;
      let lstChildrenNode = this.builDataChildren(aChild, allChildren, node);
      node['children'] = lstChildrenNode;
      objectReturn.push(node);
      this.load_tree_path.push(node);
    });
    return objectReturn;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
    document.title = `${this.rootDocumentTitle}`;
  }
  getProductById(productId) {
    this.subscriptions.push(
      this.productService
        .apiProductsIdGet(productId)
        .pipe(
          catchError((error) => {
            if (error.status === 401) {
              // Trang product detail là public, không cần đăng nhập
              // Log error nhưng không redirect
              console.warn(
                'Unauthorized access to product, but continuing to display public content'
              );
              // Có thể show thông báo nhẹ cho user
              // this.toastrService.info('Đăng nhập để xem đầy đủ thông tin sản phẩm', '', { timeOut: 3000 });
            }
            return throwError(error);
          })
        )
        .subscribe(
          (res) => {
            this.rawProductData = res.data;
            this.productData = res.data;
            this.applyProductLanguage(this.translationService.getSelectedLanguage() || localStorage.getItem('language') || 'vi');
            if (this.productData && Array.isArray(this.productData.extend_supplier_quotes)) {
              this.supplierQuotesCount = this.productData.extend_supplier_quotes.length;
            }

            if (this.productData && this.productData.name) {
              // Basic title setup
              this.titleService.setTitle(this.productData.name + ' - BimBim');
            }

            if (this.productData.extend_type && this.productData.extend_type.length > 0) {
              this.productData.extend_type.forEach((item) => {
                item.types = item.types.map((obj, index) => {
                  if (index == 0) {
                    this.lstTypeSelectedId.push(obj.id);

                    return {
                      ...obj,
                      checked: true
                    };
                  }

                  return {
                    ...obj,
                    checked: false
                  };
                });
              });

              this.lstTypeSelectedId$.next(this.lstTypeSelectedId);
            } else {
              this.price = this.productData.price;
              this.originPrice = this.productData.origin_price;
              this.quantity = this.normalizeQuantity(this.productData.quantity);
              this.save =
                this.originPrice > 0 ? Math.round(100 - (this.price / this.originPrice) * 100) : 0;

              this.loadProductWarehouses();
            }
            // this.lstTypeSelectedId$.next(this.lstTypeSelectedId);
            let item_tree = this.load_tree_path.find(
              (x) => x.id == this.productData.product_category_id
            );
            if (item_tree) {
              this.pathCategory = item_tree.path;
            }
            this.changeDetectorRef.markForCheck();
          },
          (error) => {
            // Handle error gracefully
            console.error('Error loading product:', error);
            if (error.status !== 401) {
              this.toastrService.error('Không thể tải thông tin sản phẩm', '');
            }
          }
        )
    );
  }
  getRecentlyViewed() {
    this.subscriptions.push(
      this.productService
        .apiProductsRecentlyViewedGet()
        .pipe(
          catchError((error) => {
            if (error.status === 401) {
              console.warn('Unauthorized access to recently viewed, skipping');
            }
            // Trả về empty array để không crash
            return throwError(error);
          })
        )
        .subscribe(
          (res) => {
            this.recentlyViewed$.next(res.data.collection);
          },
          (error) => {
            // Silent fail for recently viewed products
            console.log('Could not load recently viewed products');
          }
        )
    );
  }
  scrollProductViewed(value) {
    document.getElementById('scroll-element').scrollLeft += value;
  }
  scrollProductImg(value) {
    document.getElementById('scroll-img').scrollLeft += value;
  }
  productTypeSelected(lstTypeIndex, typeIndex) {
    this.productData.extend_type[lstTypeIndex].types.map((item, index) => {
      if (index == typeIndex) {
        this.lstTypeSelectedId.splice(lstTypeIndex, 1, item.id);
        this.lstTypeSelectedId$.next(this.lstTypeSelectedId);
        return (item.checked = true);
      } else {
        return (item.checked = false);
      }
    });
  }
  openBottomSheet(isBook): void {
    this.bottomSheet.open(AppProductBottomSheetComponent, {
      data: {
        data: this.productData,
        selected: this.lstTypeSelectedId,
        quantity: this.quantity,
        is_book: isBook,
        quantitySelected: this.quantitySelected
      }
    });
  }
  priceRequestPost() {
    const token = localStorage.getItem(environment.authTokenKey);
    const hasToken = !!(token && token.length > 10);
    const actuallyLoggedIn = this.isLogin || hasToken;

    if (actuallyLoggedIn) {
      if (!this.isLogin) this.isLogin = true; // Sync state
      this.priceRequestService.apiPriceRequestsPost(this.productId).subscribe((res) => {
        if (res.success) {
          this.isRequestprice = true;
        }
      });
    } else {
      this.openModalSignInUp('signin');
    }
  }

  openModalSignInUp(type) {
    const dialogRef = this.dialog.open(ModalCreateSignInUpComponent, {
      width: '900px',
      data: {
        type: type,
        returnUrl: location.pathname
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
      }
    });
  }

  addCartProduct(isOrder) {
    if (this.quantitySelected <= 0) {
      this.toastrService.warning('Số lượng không hợp lệ');
      return;
    }
    this.cartProductService
      .apiMyCartProductsPost(this.productId, this.quantitySelected, this.subTypeId)
      .subscribe((res) => {
        if (res.success) {
          this.isAddProductEmit.emit(true);
          this.cartProductService.apiMyCartProductsGet().subscribe((reslst) => {
            if (reslst.success) {
              if (reslst.data.collection.length == 0) {
                $('.numberOfProduct').text('');
              } else {
                $('.numberOfProduct').text(reslst.data.collection.length);
              }
            }
          });
          if (isOrder) {
            this.router.navigate(['cart']);
          } else {
            return this.toastrService.success(
              this.translate.instant('ECOMMERCE.PRODUCT.ADD_TO_CART_SUCCESS'),
              ''
            );
          }
        } else {
          return this.toastrService.error('Thao tác không thành công', '');
        }
      });
  }
  stepUpDownNumber(isPlus) {
    if (this.productIdFromAdminPage) {
      if (isPlus) return (this.quantitySelected += 1);
      if (!isPlus && this.quantitySelected > 1) return (this.quantitySelected -= 1);
    } else {
      // if (this.quantity == 0) return;
      if (
        isPlus
        // && this.quantity > 0 &&
        //this.quantitySelected < this.quantity
      )
        this.quantitySelected += 1;
      if (!isPlus && this.quantitySelected > 1) this.quantitySelected -= 1;
    }
  }

  //for orderdetail component
  addProductToOrder(orderId) {
    this.orderService
      .apiOrdersOrderIDProductsPost(orderId, this.productId, this.quantitySelected, this.subTypeId)
      .subscribe((res) => {
        if (res.success) {
          this.toastrService.success(this.translate.instant('ECOMMERCE.PRODUCT.PRODUCT_ADDED'), '');
          this.isAddProductEmit.emit(true);
        } else {
          this.toastrService.error('Thao tác không thành công', '');
        }
      });
  }
  getProductImage() {
    if (this.productData.extend_images) {
      return this.host + this.productData.extend_images[this.imgSelectedIndex].physical_path;
    }
  }
  hoverImg(index) {
    this.imgSelectedIndex = index;
  }
  routerLinkToProduct(productId, productName) {
    this.router.navigate([`/product/${productId}/${UtilService.slugify(productName)}/details`]);
  }

  changeQuantity(event) {
    if (!event) {
      this.quantitySelected = 0;
    } else {
      this.quantitySelected = event;
    }
  }

  doubleClick() {}

  // SEO Methods
  setupSEOTags() {
    if (!this.productData) return;

    // Basic page title
    const title = `${this.productData.name} | ${this.rootDocumentTitle}`;
    this.titleService.setTitle(title);

    // Meta description
    const description = this.createMetaDescription();
    this.updateMetaTag('description', description);

    // Keywords
    const keywords = this.createKeywords();
    this.updateMetaTag('keywords', keywords);

    // Open Graph Tags for Facebook/LinkedIn
    this.updateMetaTag('og:title', title, 'property');
    this.updateMetaTag('og:description', description, 'property');
    this.updateMetaTag('og:image', this.getProductImageForSEO(), 'property');
    this.updateMetaTag('og:url', window.location.href, 'property');
    this.updateMetaTag('og:type', 'product', 'property');
    this.updateMetaTag('og:site_name', 'BimBim - Phụ tùng và thiết bị công nghiệp', 'property');

    // Twitter Cards
    this.updateMetaTag('twitter:card', 'summary_large_image', 'name');
    this.updateMetaTag('twitter:title', title, 'name');
    this.updateMetaTag('twitter:description', description, 'name');
    this.updateMetaTag('twitter:image', this.getProductImageForSEO(), 'name');

    // Product specific meta tags
    this.updateMetaTag('product:brand', this.productData.brand_name, 'property');
    this.updateMetaTag(
      'product:availability',
      this.quantity > 0 ? 'in stock' : 'out of stock',
      'property'
    );
    this.updateMetaTag('product:condition', 'new', 'property');

    // Canonical URL
    this.updateCanonicalUrl();

    // JSON-LD Structured Data
    this.addStructuredData();

    // 🐛 DEBUG: Console log for localhost testing
    if (window.location.hostname === 'localhost') {
      console.group('🔍 SEO DEBUG INFO');
      console.log('📝 Title:', title);
      console.log('📄 Description:', description);
      console.log('🏷️ Keywords:', keywords);
      console.log('🖼️ Image:', this.getProductImageForSEO());
      console.log('🔗 Canonical:', window.location.href.split('?')[0]);
      console.log(
        '📊 Structured Data:',
        JSON.stringify(this.createStructuredDataObject(), null, 2)
      );
      console.groupEnd();
    }
  }

  private normalizeQuantity(quantity: number): number {
    const availableQuantity = Number(quantity);

    if (!Number.isFinite(availableQuantity) || availableQuantity < 0) {
      return 0;
    }

    return availableQuantity;
  }

  private updateWarehouseStocks(collection: any[]): void {
    this.warehouseStocks = collection
      .filter((item) => item.extend_repo_name && Number(item.quantity) > 0)
      .map((item) => ({
        name: item.extend_repo_name,
        quantity: this.normalizeQuantity(item.quantity)
      }));

    if (this.warehouseStocks.length > 0) {
      this.quantity = this.warehouseStocks.reduce(
        (total, warehouse) => total + warehouse.quantity,
        0
      );
    }

    this.changeDetectorRef.markForCheck();
  }

  private loadProductWarehouses(): void {
    if (!this.productId) {
      this.warehouseStocks = [];
      return;
    }

    const subscription = this.productRepoService
      .apiProductProductIDProductRepositoriesGet(this.productId, '', '', 1, 100)
      .subscribe(
        (response) => {
          const collection =
            response && response.success && response.data && response.data.collection
              ? response.data.collection
              : [];

          this.updateWarehouseStocks(collection);
        },
        () => {
          this.warehouseStocks = [];
          this.changeDetectorRef.markForCheck();
        }
      );

    this.subscriptions.push(subscription);
  }

  private loadSelectedVariantWarehouses(): void {
    if (!this.subTypeId) {
      this.warehouseStocks = [];
      return;
    }

    const subscription = this.productRepoTypeValueService
      .apiProductRepoTypeValuesGet('type_value_id==' + this.subTypeId, '', 1, 100)
      .subscribe(
        (response) => {
          const collection =
            response && response.success && response.data && response.data.collection
              ? response.data.collection
              : [];

          this.updateWarehouseStocks(collection);
        },
        () => {
          this.warehouseStocks = [];
          this.changeDetectorRef.markForCheck();
        }
      );

    this.subscriptions.push(subscription);
  }

  get selectedUnitName(): string {
    if (!this.productData.extend_type || this.productData.extend_type.length < 2) {
      return '';
    }

    const unitGroup = this.productData.extend_type[1];

    if (!unitGroup.types) {
      return '';
    }

    const selectedUnit = unitGroup.types.find((item) => item.checked);

    return selectedUnit ? selectedUnit.name : '';
  }

  private createMetaDescription(): string {
    let description = `${this.productData.name}`;

    if (this.productData.brand_name) {
      description += ` từ hãng ${this.productData.brand_name}`;
    }

    if (this.productData.sku) {
      description += ` (SKU: ${this.productData.sku})`;
    }

    if (this.productData.summary) {
      const summaryText = this.stripHtml(this.productData.summary);
      description += ` - ${summaryText.substring(0, 100)}`;
    }

    description += ` | Phụ tùng chất lượng cao, giá tốt nhất tại BimBim.`;

    return description.length > 160 ? description.substring(0, 157) + '...' : description;
  }

  private createKeywords(): string {
    const keywords = [
      this.productData.name,
      this.productData.brand_name,
      this.productData.sku,
      'phụ tùng',
      'thiết bị công nghiệp',
      'BimBim'
    ]
      .filter((keyword) => keyword && keyword.trim())
      .join(', ');

    return keywords;
  }

  private getProductImageForSEO(): string {
    if (this.productData.extend_images && this.productData.extend_images.length > 0) {
      return this.host + this.productData.extend_images[0].physical_path;
    }
    if (this.productData.default_image) {
      return this.host + this.productData.default_image;
    }
    return this.host + '/assets/media/logos/bimbimlogo.png'; // Fallback image
  }

  private updateMetaTag(name: string, content: string, attribute: string = 'name') {
    if (!content) return;

    const selector = `meta[${attribute}="${name}"]`;
    const existingTag = this.document.querySelector(selector);

    if (existingTag) {
      existingTag.setAttribute('content', content);
    } else {
      const newTag = this.document.createElement('meta');
      newTag.setAttribute(attribute, name);
      newTag.setAttribute('content', content);
      this.document.head.appendChild(newTag);
    }
  }

  private updateCanonicalUrl() {
    const canonicalUrl = window.location.href.split('?')[0]; // Remove query params

    const existingCanonical = this.document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.setAttribute('href', canonicalUrl);
    } else {
      const linkTag = this.document.createElement('link');
      linkTag.setAttribute('rel', 'canonical');
      linkTag.setAttribute('href', canonicalUrl);
      this.document.head.appendChild(linkTag);
    }
  }

  private stripHtml(html: string): string {
    const div = this.document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  private addStructuredData() {
    const structuredData = this.createStructuredDataObject();

    // Remove existing structured data
    const existingScript = this.document.querySelector(
      'script[type="application/ld+json"][data-product]'
    );
    if (existingScript) {
      existingScript.remove();
    }

    // Add new structured data
    const script = this.document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-product', 'true');
    script.textContent = JSON.stringify(structuredData);
    this.document.head.appendChild(script);
  }

  private createStructuredDataObject() {
    return {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: this.productData.name,
      image: this.getProductImageForSEO(),
      description: this.stripHtml(this.productData.summary || this.productData.description),
      sku: this.productData.sku,
      brand: {
        '@type': 'Brand',
        name: this.productData.brand_name
      },
      manufacturer: {
        '@type': 'Organization',
        name: this.productData.manufacturer_name
      },
      offers: {
        '@type': 'Offer',
        availability:
          this.quantity > 0 ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
        priceCurrency: 'VND',
        price: this.price,
        url: window.location.href
      }
    };
  }

  /**
   * Check if current user has administrative permissions
   */
  private checkIsAdmin(user: User | undefined | null): boolean {
    const adminRoles = ['Admin', 'ADMIN', 'Content Admin', 'Salesman'];
    if (user && user.roles && Array.isArray(user.roles)) {
      if ((user.roles as unknown as string[]).some((role: string) => adminRoles.includes(role))) {
        return true;
      }
    }
    try {
      const token = localStorage.getItem(environment.authTokenKey);
      if (token) {
        const parts = token.split('.');
        if (parts.length === 3) {
          const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
          const roleClaim =
            payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] ||
            payload['role'] ||
            payload['roles'];
          if (roleClaim) {
            const roles = Array.isArray(roleClaim) ? roleClaim : [roleClaim];
            if (roles.some((r: string) => adminRoles.includes(r))) {
              return true;
            }
          }
        }
      }
    } catch (e) {}
    return false;
  }

  /**
   * Check if supplier quotes tab should be accessible to the current user
   */
  get hasSupplierQuotesAccess(): boolean {
    return (
      this.isAdmin ||
      (this.productData && Array.isArray(this.productData.extend_supplier_quotes))
    );
  }

  /**
   * Update supplier quotes badge count
   */
  onSupplierQuotesCountChange(count: number): void {
    this.supplierQuotesCount = count;
  }

  sendQuestion() {}
}
